import HomeListView from './HomeListView.connect';

export default HomeListView;
